export default "__VITE_ASSET__ySZ9uMjV__"